export default __webpack_public_path__ + "static/Sales-996449f6acf4b3e3844243baba44c80f.png";